import { type Components } from '@mui/material'
export const Tab: Partial<Components> = {
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        borderRadius: '30px',
        minHeight: '20px',
        maxHeight: '30px',
        marginLeft: 5,
        marginRight: 5,
        fontWeight: 700,
        letterSpacing: 0.01
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        color: '#4D5E80',
        fontSize: 14,
        fontWeight: 500,
        letterSpacing: 0.01
      }
    }
  }
}
